import {
  FETCH_LOCATION,
  UPDATE_CURRENT_LOCATION,
  UPDATE_RADIUS,
  SET_LOCATION_DISPLAY,
} from "../actions/types";

// locationDisplay: { type: 'typed' | 'gps' | 'city', name: string | null }
const initialState = { fetchLocation: true, radius: 10, locationDisplay: null };

// const getInitialState = () => {
//   if (navigator.geolocation) {
//     const funct = navigator.geolocation.getCurrentPosition(position => {
//       const { latitude, longitude } = position.coords;
//       return { lat: latitude, lng: longitude };
//     });
//     return funct();
//   } else {
//     return { lat: 33.488677, lng: -112.345279 };

//   }
// }
// const initialState = getInitialState();

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_CURRENT_LOCATION:
      return { ...state, ...payload };
    case FETCH_LOCATION:
      return { ...state, fetchLocation: payload };
    case UPDATE_RADIUS:
      return { ...state, radius: payload };
    case SET_LOCATION_DISPLAY:
      return { ...state, locationDisplay: payload };
    default:
      return state;
  }
}
